import { render, staticRenderFns } from "./MProcessItem.vue?vue&type=template&id=2bb3bcbf&scoped=true"
import script from "./MProcessItem.vue?vue&type=script&lang=js"
export * from "./MProcessItem.vue?vue&type=script&lang=js"
import style0 from "./MProcessItem.vue?vue&type=style&index=0&id=2bb3bcbf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb3bcbf",
  null
  
)

export default component.exports